import { render, staticRenderFns } from "./NakesEdit.vue?vue&type=template&id=1372c884&scoped=true"
import script from "./NakesEdit.vue?vue&type=script&lang=js"
export * from "./NakesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372c884",
  null
  
)

export default component.exports